import type ModalConversationInterceptorService from '../commons/services/modal-conversation-interceptor.service';
import type {ExceptionActionResponseHandler} from '../commons/services/exception-action-response-handler';
import type {IHttpService} from 'angular';
import type LoginService from './login.service';

export class AuthInterceptorRegistrar {

    constructor(private modalConversationInterceptor: ModalConversationInterceptorService,
                private loginService: LoginService,
                private $http: IHttpService) {
    }

    public register() {
        const handler: ExceptionActionResponseHandler = async (exceptionActionResponse, response) => {
            await this.loginService.upgrade();
            return this.$http(response.config);
        };
        this.modalConversationInterceptor.registerExceptionActionResponseHandler('InsufficientlyAuthenticatedException', handler);
    }

}
